<span class="ant-table-column-sorter ant-table-column-sorter-full align-middle inline-block" (click)="sortOrderClicked()">
    <span class="ant-table-column-sorter-inner">
        -{{sortOrder}}
        <span nz-icon nzType="caret-up" class="ant-table-column-sorter-up" [class.active]="sortOrder === 'ascend'"> </span>
        <span nz-icon nzType="caret-down" class="ant-table-column-sorter-down" [class.active]="sortOrder === 'descend'"> </span>
    </span>
</span>
